// local columns
import actions from '../columns/actions.column';

const postStaticColumnGroup = [actions];

export default postStaticColumnGroup;
